document.addEventListener('DOMContentLoaded', function() {
  // SVG content for the icons
  const chevronDownSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  const chevronRightSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>';
  
  // Function to close all accordions
  function closeAllAccordions() {
    const allAccordionItems = document.querySelectorAll('.accordion-item');
    const allAccordionIcons = document.querySelectorAll('.accordion-icon');
    
    allAccordionItems.forEach(item => {
      item.classList.remove('active');
    });
    
    allAccordionIcons.forEach(icon => {
      icon.innerHTML = chevronRightSVG;
    });
  }
  
  // Use event delegation to handle clicks on all accordion headers, including dynamically added ones
  document.addEventListener('click', function(event) {
    // Check if the clicked element is an accordion header or a child of one
    const accordionHeader = event.target.closest('.accordion-header');
    
    if (accordionHeader) {
      const accordionItem = accordionHeader.closest('.accordion-item');
      const accordionContent = accordionHeader.nextElementSibling;
      const isActive = accordionItem.classList.contains('active');
      
      // Close all accordions first
      closeAllAccordions();
      
      // If the clicked item wasn't active before, open it
      if (!isActive) {
        // Open this accordion
        accordionItem.classList.add('active');
        accordionHeader.querySelector('.accordion-icon').innerHTML = chevronDownSVG;
      }
      // If it was active, it's now closed (by closeAllAccordions)
    }
  });
  
  // Open the first accordion by default
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  if (accordionHeaders.length > 0) {
    const firstAccordionItem = accordionHeaders[0].parentElement;
    const firstAccordionContent = accordionHeaders[0].nextElementSibling;
    
    firstAccordionItem.classList.add('active');
    firstAccordionContent.style.display = 'block';
    accordionHeaders[0].querySelector('.accordion-icon').innerHTML = chevronDownSVG;
  }
});
